import { render } from "./LeaveApprovals.vue?vue&type=template&id=3627befa"
import script from "./LeaveApprovals.vue?vue&type=script&lang=js"
export * from "./LeaveApprovals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__